import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { generateQueryString } from "src/util/helper";
import IQueryTradesBasicInfo from "../queryStrings/IQueryTradesBasicInfo";
import { saveByteArray } from "src/util/saveByteArray";
import { IExposure } from "../interface/report/IExposure";
import IQueryDealsBasicInfo from '../queryStrings/IQueryDealsBasicInfo';
import { ILastTradeAction } from '../interface/report/ILastTradeAction';
import { IExpenseReport } from '../interface/report/IExpenseReport';
import { Dayjs } from "dayjs";
import { IPendencyTrade } from "../interface/report/IPendencyTrade";
import IQueryDebtRolloverInfo from '../queryStrings/IQueryDebtRolloverInfo';

enum ReportServiceEnum {
  exportTrades = "/export-trade?",
  exportDeals = "/export-deal?",
  acquired = "/acquired",
  movement = "/movement",
  historySource = "/history-source",
  historyType = "/history-type",
  historyExposure = "/history-exposure",
  rejectedTrades = "/rejected-trades",
  pendencyTrades = "/pendency-trades",
  paidExpenses = "/expenses/paid",
  exportReportDebtRollover = "/debt-rollover-report",
  exportReportDebtRolloverNotification = "/debt-rollover-notification",
  postPurchaseCommission = "/post-purchase-commission",

  sendLegal = "/send-legal",
  sendPending = "/send-pending-precatorios",
  sendAcquired = "/send-acquired",
  sendAcquiredPreview = "/send-acquired-preview",
  sendPostPurchase = "/send-post-purchase",
  sendDisbursementMetrics = "/send-disbursement-metrics",
  sendFunnel = "/send-funnel",
  sendPaymentsLate = "/send-payments-late",
  sendCartorioAttorneySining = "/send-cartorio-attorney",
}

export class ReportService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/report");
  }

  public exportTrades = async (queryString: IQueryTradesBasicInfo) => {
    const data = await this.GET(`${ReportServiceEnum.exportTrades}${generateQueryString(queryString)}`, "blob");
    saveByteArray("trades.xlsx", data);
    return data;
  };

  public getPostPurchaseCommission = async (start: Dayjs, end: Dayjs) => {
    const data = await this.GET(`${ReportServiceEnum.postPurchaseCommission}?${generateQueryString({
      start: start.unix(),
      end: end.unix()
    })}`, "blob");
    saveByteArray("relatorio_comissoes_pos_compra.xlsx", data);
    return data;
  };

  public exportDeals = async (queryString: IQueryDealsBasicInfo) => {
    const data = await this.GET(`${ReportServiceEnum.exportDeals}${generateQueryString(queryString)}`, "blob");
    saveByteArray("deals.xlsx", data);
    return data;
  };

  public exportReportDebtRollover = async (queryString: IQueryDebtRolloverInfo) => {
    const data = await this.GET(`${ReportServiceEnum.exportReportDebtRollover}?${generateQueryString(queryString)}`, "blob");
    saveByteArray("rolagem.xlsx", data);
    return data;
  };

  public getExposureHistory = async (): Promise<IExposure[]> => await this.GET(ReportServiceEnum.historyExposure);
  public getExposureHistoryByTradeId = async (id: number): Promise<IExposure[]> => await this.GET(`${ReportServiceEnum.historyExposure}/${id}`);
  public getAcquiredReport = async (): Promise<any> => await this.GET(ReportServiceEnum.acquired);
  public getMovementReport = async (): Promise<any> => await this.GET(ReportServiceEnum.movement);
  public getHistorySourceReport = async (): Promise<any> => await this.GET(ReportServiceEnum.historySource);
  public getHistoryTypeReport = async (): Promise<any> => await this.GET(ReportServiceEnum.historyType);
  public getRejectedTrades = async (start: Dayjs, end: Dayjs): Promise<ILastTradeAction[]> => await this.GET(`${ReportServiceEnum.rejectedTrades}?${generateQueryString({
    start: start.unix(),
    end: end.unix()
  })}`);
  public getPendencyTrades = async (start: Dayjs, end: Dayjs): Promise<IPendencyTrade[]> => await this.GET(`${ReportServiceEnum.pendencyTrades}?${generateQueryString({
    startDateTS: start.unix(),
    endDateTS: end.unix()
  })}`);
  public getPaidExpensesReport = async (start: Dayjs, end: Dayjs): Promise<IExpenseReport[]> => await this.GET(`${ReportServiceEnum.paidExpenses}?${generateQueryString({
    start: start.unix(),
    end: end.unix()
  })}`);


  public sendLegalReportEmail = async (): Promise<void> => await this.GET(ReportServiceEnum.sendLegal);
  public sendPendingReportEmail = async (): Promise<void> => await this.GET(ReportServiceEnum.sendPending);
  public sendAcquiredReportEmail = async (): Promise<void> => await this.GET(ReportServiceEnum.sendAcquired);
  public sendAcquiredPreviewReportEmail = async (): Promise<void> => await this.GET(ReportServiceEnum.sendAcquiredPreview);
  public sendPostPurchaseReportEmail = async (): Promise<void> => await this.GET(ReportServiceEnum.sendPostPurchase);
  public sendDisbursementMetricsReportEmail = async (): Promise<void> => await this.GET(ReportServiceEnum.sendDisbursementMetrics);
  public sendFunnelReportEmail = async (): Promise<void> => await this.GET(ReportServiceEnum.sendFunnel);
  public sendPaymentsLateReportEmail = async (): Promise<void> => await this.GET(ReportServiceEnum.sendPaymentsLate);
  public sendCartorioAttorneySiningEmil = async (): Promise<void> => await this.GET(ReportServiceEnum.sendCartorioAttorneySining);
  public exportReportDebtRolloverNotification = async (): Promise<void> => await this.GET(ReportServiceEnum.exportReportDebtRolloverNotification);
}
